import React from 'react';
import './AppToolPassword.css';

class AppToolPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      copy_msg: '',
      config: {
        length: 12,
        includeUppercase: true,
        includeLowercase: true,
        includeNumbers: true,
        customSymbols: '@%!$&_+.',
        excludeSimilar: true,
        firstCharLetter: true,
      lastCharLetter: true,
      },
      showConfig: false,
    };
    this.handleGenerate = this.handleGenerate.bind(this);
    this.handleCopy = this.handleCopy.bind(this);
    this.handleConfigChange = this.handleConfigChange.bind(this);
    this.toggleConfig = this.toggleConfig.bind(this);
    this.handleCustomSymbolsChange = this.handleCustomSymbolsChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
  }

  componentDidMount() {
    this.handleGenerate();
  }

  generateRandomChar(charSet, excludeSimilar, excludeChars = []) {
    let chars = charSet;
    
    if (excludeSimilar) {
      const similarChars = 'il1Lo0O';
      chars = chars.split('').filter(char => !similarChars.includes(char)).join('');
    }
    
    // 排除已使用的字符
    if (excludeChars.length > 0) {
      chars = chars.split('').filter(char => !excludeChars.includes(char)).join('');
    }
    
    return chars.charAt(Math.floor(Math.random() * chars.length));
  }

  handleGenerate() {
    const { config } = this.state;
    let charSet = '';
    
    if (config.includeUppercase) {
      charSet += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    }
    if (config.includeLowercase) {
      charSet += 'abcdefghijklmnopqrstuvwxyz';
    }
    if (config.includeNumbers) {
      charSet += '0123456789';
    }
    
    if (charSet === '') {
      this.setState({ 
        password: '', 
        copy_msg: '请至少选择一种字符类型' 
      });
      return;
    }
    
    let generatedPassword = '';
    
    // 第一个字符必须是字母
    if (config.firstCharLetter) {
      generatedPassword += this.generateRandomLetter();
    }
    
    // 计算剩余需要生成的字符数
    const remainingLength = config.length - (config.firstCharLetter ? 1 : 0) - (config.lastCharLetter ? 1 : 0);
    
    // 确保特殊字符的出现
    // 生成基础字符集（不含特殊字符）
    let baseCharSet = charSet;
    
    // 先生成基础字符部分
    for (let i = 0; i < remainingLength; i++) {
      generatedPassword += this.generateRandomChar(baseCharSet, config.excludeSimilar);
    }
    
    // 将生成的字符打乱顺序
    let passwordArray = generatedPassword.split('');
    
    // 确保特殊字符的出现
    if (config.customSymbols && config.customSymbols.length > 0) {
      // 决定特殊字符的数量 (1-3个)
      const maxSpecialChars = Math.min(3, remainingLength);
      const specialCharCount = Math.max(1, Math.floor(Math.random() * maxSpecialChars) + 1);
      
      // 在随机位置插入特殊字符，确保特殊字符不重复
      const usedSpecialChars = [];
      for (let i = 0; i < specialCharCount; i++) {
        const specialChar = this.generateRandomChar(config.customSymbols, config.excludeSimilar, usedSpecialChars);
        
        // 如果无法获取不同的特殊字符（比如特殊字符池不够大），则允许重复
        if (specialChar) {
          usedSpecialChars.push(specialChar);
        } else {
          // 如果没有可用的不同特殊字符，重新生成（允许重复）
          const fallbackChar = this.generateRandomChar(config.customSymbols, config.excludeSimilar);
          usedSpecialChars.push(fallbackChar);
        }
        
        // 随机选择插入位置（避开第一个和最后一个字符位置如果是字母首尾）
        const availablePositions = config.firstCharLetter ? 
          passwordArray.slice(1, config.lastCharLetter ? -1 : undefined).length + 1 : 
          config.lastCharLetter ? passwordArray.slice(0, -1).length + 1 : 
          passwordArray.length + 1;
        const insertPosition = Math.floor(Math.random() * availablePositions);
        
        // 调整插入位置（考虑字母开头的情况）
        const actualPosition = config.firstCharLetter ? insertPosition + 1 : insertPosition;
        passwordArray.splice(actualPosition, 0, specialChar);
      }
    }
    
    // 确保数字的出现
    if (config.includeNumbers && remainingLength > 0) {
      // 检查是否已经包含数字
      const hasNumber = passwordArray.some(char => /[0-9]/.test(char));
      
      if (!hasNumber) {
        // 随机选择一个非首尾位置替换为数字
        const availablePositions = [];
        for (let i = 0; i < passwordArray.length; i++) {
          const isFirstChar = config.firstCharLetter && i === 0;
          const isLastChar = config.lastCharLetter && i === passwordArray.length - 1;
          if (!isFirstChar && !isLastChar) {
            availablePositions.push(i);
          }
        }
        
        if (availablePositions.length > 0) {
          const randomPosition = availablePositions[Math.floor(Math.random() * availablePositions.length)];
          const numbers = '0123456789';
          const randomNumber = numbers.charAt(Math.floor(Math.random() * numbers.length));
          passwordArray[randomPosition] = randomNumber;
        }
      }
    }
    
    generatedPassword = passwordArray.join('');
    
    // 最后一个字符必须是字母
    if (config.lastCharLetter) {
      generatedPassword += this.generateRandomLetter();
    }
    
    this.setState({ 
      password: generatedPassword, 
      copy_msg: '' 
    });
  }

  handlePasswordChange(e) {
    const newPassword = e.target.value;
    this.setState({ 
      password: newPassword,
      copy_msg: ''
    });
  }

  handleConfigChange(key, value) {
    this.setState(prevState => ({
      config: {
        ...prevState.config,
        [key]: value
      }
    }), () => {
      this.handleGenerate();
    });
  }

  handleCustomSymbolsChange(e) {
    let value = e.target.value;
    this.handleConfigChange('customSymbols', value);
  }

  generateRandomLetter() {
    const letters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return letters.charAt(Math.floor(Math.random() * letters.length));
  }

  toggleConfig() {
    this.setState(prevState => ({
      showConfig: !prevState.showConfig
    }));
  }

  handleCopy() {
    if (!this.state.password) return;
    try {
      navigator.clipboard.writeText(this.state.password).then(() => {
        this.setState({ copy_msg: 'Copy success' });
      }).catch(() => {
        this.setState({ copy_msg: 'Copy failed' });
      });
    } catch (err) {
      this.setState({ copy_msg: 'Copy failed' });
    }
  }

  render() {
    const { password, copy_msg, config, showConfig } = this.state;

    return (
      <div id="tool_password">
        <div id="content_box">
          <div className="config-panel">
            <button 
              className="config-toggle" 
              onClick={this.toggleConfig}
            >
              {showConfig ? '隐藏配置' : '显示配置'}
            </button>
            
            {showConfig && (
              <div className="config-options">
                <div className="config-row">
                  <label>密码长度:</label>
                  <input 
                    type="number" 
                    min="4" 
                    max="128"
                    value={config.length} 
                    onChange={(e) => this.handleConfigChange('length', parseInt(e.target.value))}
                  />
                </div>

                <div className="config-row">
                  <label>
                    <input 
                      type="checkbox" 
                      checked={config.includeUppercase} 
                      onChange={(e) => this.handleConfigChange('includeUppercase', e.target.checked)}
                    />
                    包含大写字母 (A-Z)
                  </label>
                </div>

                <div className="config-row">
                  <label>
                    <input 
                      type="checkbox" 
                      checked={config.includeLowercase} 
                      onChange={(e) => this.handleConfigChange('includeLowercase', e.target.checked)}
                    />
                    包含小写字母 (a-z)
                  </label>
                </div>

                <div className="config-row">
                  <label>
                    <input 
                      type="checkbox" 
                      checked={config.includeNumbers} 
                      onChange={(e) => this.handleConfigChange('includeNumbers', e.target.checked)}
                    />
                    包含数字 (0-9)
                  </label>
                </div>

                <div className="config-row">
                  <label>特殊字符:</label>
                  <input 
                    type="text" 
                    value={config.customSymbols} 
                    onChange={this.handleCustomSymbolsChange}
                    placeholder="输入特殊字符，留空则不包含"
                  />
                </div>

                <div className="config-row">
                  <label>
                    <input 
                      type="checkbox" 
                      checked={config.excludeSimilar} 
                      onChange={(e) => this.handleConfigChange('excludeSimilar', e.target.checked)}
                    />
                    排除相似字符 (il1Lo0O)
                  </label>
                </div>

                <div className="config-row">
                  <label>
                    <input 
                      type="checkbox" 
                      checked={config.firstCharLetter} 
                      onChange={(e) => this.handleConfigChange('firstCharLetter', e.target.checked)}
                    />
                    首字符是字母
                  </label>
                </div>

                <div className="config-row">
                  <label>
                    <input 
                      type="checkbox" 
                      checked={config.lastCharLetter} 
                      onChange={(e) => this.handleConfigChange('lastCharLetter', e.target.checked)}
                    />
                    尾字符是字母
                  </label>
                </div>
              </div>
            )}
          </div>

          <div className="password-container">
            <div className="password-buttons">
              <button onClick={this.handleGenerate} className="generate-btn">
                生成密码
              </button>
              {password && (
                <button onClick={this.handleCopy} className="copy-btn">
                  复制
                </button>
              )}
            </div>
            <input 
              type="text" 
              value={password} 
              onChange={this.handlePasswordChange}
              placeholder="点击生成密码按钮生成随机密码，或直接输入自定义密码"
              className="password-input"
            />
            {copy_msg && <div className={`copy-message ${copy_msg.includes('success') ? 'success' : 'error'}`}>{copy_msg}</div>}
          </div>

          {password && (
            <div className="password-info">
              <div className="password-strength">
                <strong>密码强度:</strong> 
                {password.length >= 12 && /[A-Z]/.test(password) && /[a-z]/.test(password) && /[0-9]/.test(password) && /[^A-Za-z0-9]/.test(password) ? 
                  <span className="strength-strong">强</span> : 
                  password.length >= 8 && /[A-Z]/.test(password) && /[a-z]/.test(password) && /[0-9]/.test(password) ? 
                  <span className="strength-medium">中等</span> : 
                  <span className="strength-weak">弱</span>
                }
              </div>
              <div className="password-length">
                <strong>密码长度:</strong> {password.length} 位
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default AppToolPassword;